/**
 * region for helpers*/
import typing from '../typing';
import validation from '../validation';
import ajax from '../ajax';

/**
 * region for constans*/
import Constants from '../../constants/Constants';


class rules {

    static required (value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            let _value;
            if (typing.isString(value)) {
                _value = typing.stripTags(value);
            }
            else {
                _value = value;
            }

            if (!typing.isEmpty(_value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                const alias = validation.getFieldAlias(tableName, fieldName);
                resolve({ valid: false, text: `${alias} is required`, field: fieldName });
            }
        });
    }

    static numeric (value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || value === '') {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (typing.isNumber(value)) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} is not numeric`, field: fieldName });
                }
            }
        });
    }

    static email (value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (typing.isEmpty(value) || typing.isEmail(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                const alias = validation.getFieldAlias(tableName, fieldName);
                resolve({ valid: false, text: `${alias} is not a valid email`, field: fieldName });
            }
        });
    }

    static url (value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (typing.isEmpty(value) || typing.isUrl(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                const alias = validation.getFieldAlias(tableName, fieldName);
                resolve({ valid: false, text: `${alias} is not a valid url`, field: fieldName });
            }
        });
    }

    static min (minValue, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || value === '' || isNaN(parseFloat(value)) || !isFinite(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (value >= minValue) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} is minor than ${minValue}`, field: fieldName });
                }
            }
        });
    }

    static max (maxValue, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || value === '' || isNaN(parseFloat(value)) || !isFinite(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (value <= maxValue) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} is greater than ${maxValue}`, field: fieldName });
                }
            }
        });
    }

    static range (minValue, maxValue, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || value === '' || isNaN(parseFloat(value)) || !isFinite(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (value <= maxValue && value >= minValue) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} should be among ${minValue} and ${maxValue}`, field: fieldName });
                }
            }
        });
    }

    static maxLength (maximunLength, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || typing.isEmpty(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (value.length <= maximunLength) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} has more than ${maximunLength} characters`, field: fieldName });
                }
            }
        });
    }

    static maxLengthNoCountHTML (maximunLength, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || typing.isEmpty(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (typing.stripTags(value).length <= maximunLength) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} has more than ${maximunLength} characters`, field: fieldName });
                }
            }
        });
    }

    static minLength (minimunLength, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || typing.isEmpty(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (value.length >= minimunLength) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} has less than ${minimunLength} characters`, field: fieldName });
                }
            }
        });
    }

    static minLengthNoCountHTML (minimunLength, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || typing.isEmpty(value)) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (typing.stripTags(value).length >= minimunLength) {
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    resolve({ valid: false, text: `${alias} has less than ${minimunLength} characters`, field: fieldName });
                }
            }
        });
    }

    static accept (acceptedTypes, files, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            let valid = true;
            const invalidFiles = [];

            if (files) {
                for (let i = 0; i < files.length; i++) {
                    const extension = files[i].name.split('.').pop();
                    if (!acceptedTypes.contains(extension)) {
                        valid = false;
                        invalidFiles.push(files[i].name);
                    }
                }
            }

            if (valid) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                resolve({ valid: false, text: `${invalidFiles} has no valid extension.`, field: fieldName });
            }
        });
    }

    static maxSize (maxSize, files, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            let valid = true;
            const invalidFiles = [];

            if (files) {
                for (let i = 0; i < files.length; i++) {
                    if (files[i].size > maxSize) {
                        valid = false;
                        invalidFiles.push(files[i].name);
                    }
                }
            }

            if (valid) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                resolve({ valid: false, text: `${invalidFiles} cannot have more than ${maxSize / 100000}MB.`, field: fieldName });
            }
        });
    }

    static afterThanField (afterThanField, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || typing.isEmpty(value) || !row[afterThanField]) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (new Date(row[afterThanField]) <= new Date(value)) {
                    if (row[fieldName] !== value) {
                        //To avoid an infinte loop of event triggering same events
                        window.dispatchEvent(new window.CustomEvent(`validation:${tableName}`));
                    }
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    const aliasAfterThan = validation.getFieldAlias(tableName, afterThanField);
                    resolve({ valid: false, text: `${alias} can not be before than ${aliasAfterThan}`, field: fieldName });
                }
            }
        });
    }

    static beforeThanField (beforeThanField, value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || typing.isEmpty(value) || !row[beforeThanField]) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (new Date(row[beforeThanField]) >= new Date(value)) {
                    if (row[fieldName] !== value) {
                        //To avoid an infinte loop of event triggering same events
                        window.dispatchEvent(new window.CustomEvent(`validation:${tableName}`));
                    }
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    const alias = validation.getFieldAlias(tableName, fieldName);
                    const aliasBeforeThan = validation.getFieldAlias(tableName, beforeThanField);
                    resolve({ valid: false, text: `${alias} can not be after than ${aliasBeforeThan}`, field: fieldName });
                }
            }
        });
    }

    static isDateDifferenceLessThan(startDateField, value, tableName, fieldName, row) {
        var daysDifference = 15;
        return new Promise(function (resolve, reject) {
            if (!value || typing.isEmpty(value) || !row[startDateField]) {
                resolve({ valid: true, field: fieldName });
            }
            else {
                if (typing.dateDiffInDays(new Date(value), new Date(row[startDateField])) <= daysDifference) {
                    if (row[fieldName] !== value) {
                        //To avoid an infinte loop of event triggering same events
                        window.dispatchEvent(new window.CustomEvent(`validation:${tableName}`));
                    }
                    resolve({ valid: true, field: fieldName });
                }
                else {
                    resolve({ valid: false, text: `Difference between dates should not be longer than ${daysDifference} days`, field: fieldName });
                }
            }
        });
    }

    static isKeywordRepeated(value, tableName, fieldName, row) {
        return new Promise(function (resolve, reject) {
            if (!value || value === '') {
                resolve({ valid: true, field: fieldName });
            }
            else {
                ajax.get(Constants.ROUTE_API_VALIDATION_ISKEYWORD_REPEATED, {
                    requestData: { 'keyword': value },
                    success: function (response) {
                        if (response.data && response.data.isValid) {
                            resolve({ valid: true, field: fieldName });
                        } else {
                            const alias = validation.getFieldAlias(tableName, fieldName);
                            resolve({ valid: false, text: `${alias} already exists`, field: fieldName });
                        }
                    }
                })
            }
        });
    }


    static IsCategoryExist(value) {
        return new Promise(function (resolve, reject) {
            if (!value || value === '') {
                resolve({ valid: false, text: `This field is required` });
            }
            else {
                ajax.get(Constants.ROUTE_API_VALIDATION_ISCATEGORY_EXISTS, {
                    requestData: { 'category': value },
                    success: function (response) {
                        if (response.data && response.data.isValid) {
                            resolve({ valid: true , text : '' });
                        } else {
                            resolve({ valid: false, text: `This sub-category already exists` });
                        }
                    }
                })
            }
        });
    }
}

export default rules;